import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-include-audit-trail',
  templateUrl: './include-audit-trail.component.html',
  styleUrls: ['./include-audit-trail.component.css']
})
export class IncludeAuditTrailComponent  {

  includeAuditTrail: boolean = false;

  selectedOption: string = 'exclude';

  constructor(public dialogRef: MatDialogRef<IncludeAuditTrailComponent>) {}

  download(): void {
    this.includeAuditTrail = this.selectedOption === 'include';
    this.dialogRef.close(true);
  }

}
